import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './合成_2.webp'
import _imports_1 from './完成.png'


const _withScopeId = n => (_pushScopeId("data-v-486e8302"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "qualitychecksafe-container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "button" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("结束巡检")
const _hoisted_6 = {
  key: 0,
  src: _imports_0,
  alt: "",
  style: {"width":"200px"}
}
const _hoisted_7 = {
  key: 1,
  class: "success_class"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  style: {"width":"100px","margin-bottom":"20px"}
}, null, -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 视频上传成功 ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("关闭")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_responsibilityperson = _resolveComponent("responsibilityperson")!
  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!
  const _component_Video = _resolveComponent("Video")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      "left-arrow": "",
      title: _ctx.$route.meta.title,
      placeholder: "",
      onClickLeft: _ctx.goBack
    }, null, 8, ["title", "onClickLeft"]),
    _createVNode(_component_van_form, { onSubmit: _ctx.onSubmit }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_van_field, {
            modelValue: _ctx.form.title,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.title) = $event)),
            readonly: "",
            label: "巡检名称："
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_van_field, {
            modelValue: _ctx.form.checkTypeText,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.checkTypeText) = $event)),
            readonly: "",
            label: "巡检类型："
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_van_field, {
            modelValue: _ctx.form.deviceName,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.deviceName) = $event)),
            readonly: "",
            label: "巡检设备："
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_van_field, {
            modelValue: _ctx.form.description,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.description) = $event)),
            rows: "2",
            autosize: "",
            readonly: "",
            label: "巡检描述：",
            type: "textarea",
            "show-word-limit": ""
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_van_field, {
            modelValue: _ctx.form.startTime,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.startTime) = $event)),
            readonly: "",
            label: "开始时间："
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_van_field, {
            modelValue: _ctx.form.endTime,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.endTime) = $event)),
            readonly: "",
            label: "结束时间："
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_van_field, {
            modelValue: _ctx.form.timeCount,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.timeCount) = $event)),
            readonly: "",
            label: "巡检时长："
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_van_field, {
            modelValue: _ctx.form.checkerName,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.checkerName) = $event)),
            readonly: "",
            label: "巡检人："
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_van_field, {
            modelValue: _ctx.resultText,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.resultText) = $event)),
            rules: [{ required: true, message: '巡检结果必填' }],
            "is-link": "",
            required: "",
            readonly: "",
            clickable: "",
            label: "巡检结果",
            placeholder: "请选择类型",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.resultPicker = true))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_van_popup, {
            show: _ctx.resultPicker,
            "onUpdate:show": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.resultPicker) = $event)),
            position: "bottom"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_picker, {
                columns: _ctx.resultPickerscolumns,
                "show-toolbar": "",
                "value-key": "name",
                onConfirm: _ctx.resultPickersonConfirm,
                onCancel: _cache[10] || (_cache[10] = ($event: any) => (_ctx.resultPicker = false))
              }, null, 8, ["columns", "onConfirm"])
            ]),
            _: 1
          }, 8, ["show"])
        ]),
        (_ctx.submitform.result === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_responsibilityperson, {
                onSelectPerson: _ctx.selectPerson,
                onSelectPersonName: _ctx.selectPersonName
              }, null, 8, ["onSelectPerson", "onSelectPersonName"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.submitform.result === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_van_field, {
                modelValue: _ctx.rectifyCompleteTime,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.rectifyCompleteTime) = $event)),
                rules: [{ required: true, message: '责任完成日期必填' }],
                "is-link": "",
                required: "",
                readonly: "",
                clickable: "",
                label: "责任完成日期",
                placeholder: "请选择日期",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.completeTimePicker = true))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_van_popup, {
                show: _ctx.completeTimePicker,
                "onUpdate:show": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.completeTimePicker) = $event)),
                position: "bottom"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_datetime_picker, {
                    type: "date",
                    title: "选择年月日",
                    "min-date": _ctx.minDate,
                    formatter: _ctx.formatter,
                    modelValue: _ctx.currentDate,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.currentDate) = $event)),
                    onConfirm: _ctx.completeTimePickerConfirm,
                    onCancel: _cache[15] || (_cache[15] = ($event: any) => (_ctx.completeTimePicker = false))
                  }, null, 8, ["min-date", "formatter", "modelValue", "onConfirm"])
                ]),
                _: 1
              }, 8, ["show"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_van_button, {
            block: "",
            disabled: _ctx.flag,
            type: "primary",
            "native-type": "submit"
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit"]),
    _createVNode(_component_Video, {
      show: _ctx.show,
      onClose: _ctx.closeVideo,
      deviceNo: _ctx.deviceNo
    }, null, 8, ["show", "onClose", "deviceNo"]),
    _createVNode(_component_van_popup, {
      show: _ctx.videoShow,
      "onUpdate:show": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.videoShow) = $event)),
      "close-on-click-overlay": false
    }, {
      default: _withCtx(() => [
        (!_ctx.showEnd)
          ? (_openBlock(), _createElementBlock("img", _hoisted_6))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _hoisted_8,
              _hoisted_9,
              _createVNode(_component_van_button, {
                onClick: _ctx.closeToBack,
                block: "",
                type: "primary",
                size: "small",
                style: {"margin-top":"20px"}
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              }, 8, ["onClick"])
            ]))
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}